<script setup lang="ts">
defineProps<{
  visible: boolean;
  top: number;
  left: number;
}>();

const emit = defineEmits<{
  quote: [];
}>();
</script>

<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="ai-page-quote-floater"
      :style="{ top: `${top}px`, left: `${left}px` }"
      @mousedown.prevent
    >
      <button type="button" class="ai-page-quote-floater-btn" @click="emit('quote')">
        引用到AI对话
      </button>
    </div>
  </Teleport>
</template>

<style scoped>
.ai-page-quote-floater {
  position: fixed;
  z-index: 6000;
  transform: translateX(-50%);
}

.ai-page-quote-floater-btn {
  padding: 6px 12px;
  border: 1px solid #d0e3ff;
  border-radius: 8px;
  background: #fff;
  color: #0052d9;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(15, 35, 52, 0.12);
  white-space: nowrap;
}

.ai-page-quote-floater-btn:hover {
  background: #f0f6ff;
  border-color: #0052d9;
}
</style>
